import { OrderPerson } from 'entities/orders';
import {
	PersonLastVisit,
	PersonNotesMarker,
	selectPersons,
	selectPersonsError,
} from 'entities/person';
import { getPerson } from 'entities/person';
import { Tags } from 'entities/tags';
import { useEffect, useState } from 'react';
import { useModal } from 'shared/lib/modal';
import { PaginationHook, usePaginationFilter } from 'shared/lib/pagination';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import { GridRows, GridTable } from 'shared/ui/gridTable';

export const PersonTableList = () => {
	const [rows, setRows] = useState<GridRows[]>([]);
	const [currentRowId, setCurrentRowId] = useState<number | undefined>(
		undefined,
	);
	const { isLoading, isLoadingMore, loadMore } =
		usePaginationFilter() as PaginationHook;
	const { openModal } = useModal();

	const persons = useAppSelector(selectPersons);
	const error = useAppSelector(selectPersonsError);
	const dispatch = useAppDispatch();

	useEffect(() => {
		if (persons.length) {
			const personsMap = persons.map(person => {
				return {
					id: person.id,
					fields: [
						<OrderPerson
							person={person}
							textBold={true}
							width="25vw"
						/>,
						<PersonLastVisit person={person} />,
						<Tags
							tags={person.tags}
							tagsFor={'person'}
							currentEntityId={person.id}
						/>,
						<PersonNotesMarker person={person} />,
					],
				};
			});

			setRows([{ rows: [{ cells: personsMap }] }]);
		} else {
			setRows([]);
		}
	}, [persons]);

	const selectPerson = async (id: number) => {
		setCurrentRowId(id);
		dispatch(getPerson({ id }));
		openModal();
	};

	return (
		<GridTable
			tableRows={rows}
			columnCount={4}
			gridSettings={{
				moreSpaceForLastColumn: false,
				columnSize: 2,
			}}
			specificColumnSizes={[
				{ index: 1, size: 10 },
				{ index: 2, size: 5 },
				{ index: 3, size: 16 },
			]}
			isLoading={isLoading && !isLoadingMore}
			error={error}
			isLoadingBottom={isLoadingMore}
			onClickOnCard={selectPerson}
			selectedRowId={currentRowId}
			onScrollEnd={loadMore}
		/>
	);
};
